module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("Cultural Resource Group "), _c('b', [_vm._v(_vm._s(this.crr.smithsonianNumber))])]), _vm._v(" "), _c('h4'), _vm._v(" "), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.isEmptyGroup) ? _c('div', [_c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "info"
    }
  }, [_c('strong', [_vm._v("This Cultural Resource is not currently a part of any Cultural Resource Group")]), _vm._v(" "), _c('br'), _vm._v("\r\n                Either create a new group, or add it to an existing group\r\n                "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.createGroup()
      }
    }
  }, [_vm._v("Create New Group")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.addToExistingGroupSearch()
      }
    }
  }, [_vm._v("Add To Existing Group")])])])]) : _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "panel panel-offset"
  }, [_vm._m(0), _vm._v(" "), (_vm.groupHeadList.length > 0) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.groupHeadList,
      "columns": _vm.headGridSpec.columns,
      "options": _vm.headGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "remove",
      fn: function(props) {
        return [(_vm.isEdit) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-remove",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.removeHead(props.row.culturalResourceId)
            }
          }
        })]) : _vm._e()]
      }
    }])
  })], 1)]) : _c('div', {
    staticClass: "panel-body"
  }, [_vm._m(1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "panel panel-offset"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.memberList.length > 0) ? _c('div', [_c('v-client-table', {
    attrs: {
      "data": _vm.memberList,
      "columns": _vm.memberGridSpec.columns,
      "options": _vm.memberGridSpec.options
    },
    scopedSlots: _vm._u([{
      key: "memberType",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(props.row.segment > 0 ? 'Segment' : 'Member'))])]
      }
    }, {
      key: "addHead",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isEdit),
            expression: "isEdit"
          }],
          staticStyle: {
            "text-align": "center"
          }
        }, [(props.row.segment < 1) ? _c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.setHead(props.row.culturalResourceGroupId)
            }
          }
        }, [_vm._v("Add to Head")]) : _vm._e()])]
      }
    }, {
      key: "addAnotherGroup",
      fn: function(props) {
        return [(_vm.isEdit) ? _c('div', {
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('button', {
          staticClass: "btn",
          on: {
            "click": function($event) {
              _vm.addToDifferentGroup(props.row)
            }
          }
        }, [_vm._v("Add to another group")])]) : _vm._e()]
      }
    }, {
      key: "remove",
      fn: function(props) {
        return [_c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isEdit),
            expression: "isEdit"
          }],
          staticStyle: {
            "text-align": "center"
          }
        }, [_c('a', {
          staticClass: "fa fa-remove",
          staticStyle: {
            "font-size": "18px"
          },
          on: {
            "click": function($event) {
              _vm.removeMemberFromGroup(props.row.culturalResourceGroupId)
            }
          }
        })])]
      }
    }])
  })], 1) : _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "info"
    }
  }, [_c('div', {
    staticClass: "text-label"
  }, [_vm._v("\r\n                                There are no members for this group\r\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }],
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.showSearch()
      }
    }
  }, [_vm._v("Add Member")])])])])])])]), _vm._v(" "), _c('modal', {
    ref: "culturalResourceSearchModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cultural Resource Search")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('culturalResourceSearch', {
    attrs: {
      "addCulturalResource": _vm.addMemberToGroup,
      "resultFilter": _vm.filterExisting
    }
  })], 1)]), _vm._v(" "), _c('modal', {
    ref: "headSearchModal"
  }, [_c('h3', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("Cultural Resource Search")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('culturalResourceSearch', {
    attrs: {
      "addCulturalResource": _vm.addToGroup,
      "resultFilter": _vm.filterHasResourceId
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.culturalResourceRecordingId),
      expression: "culturalResourceRecordingId"
    }]
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.goRecording()
      }
    }
  }, [_vm._v(_vm._s(_vm.productionAdminEdit ? 'Return to Production Record' : 'Return to Recording'))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Heads")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info",
    attrs: {
      "role": "info"
    }
  }, [_c('div', {
    staticClass: "text-label"
  }, [_vm._v("\r\n                                There is no head for this group\r\n                            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading green-bg"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Members")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca163548"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CulturalResourceGroup.vue
// module id = 994
// module chunks = 1